"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonPrimary = ButtonPrimary;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _core = require("@material-ui/core");

var _colors = require("../../theme/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: function root(_ref) {
      var size = _ref.size;
      return {
        borderRadius: '58px',
        textTransform: 'none',
        color: _colors.colors.black,
        padding: size === 'small' ? '4px 16px 4px 16px' : '8px 24px',
        '&:hover': {
          backgroundColor: _colors.colors.primaryGreenHover
        },
        '&:disabled': {
          backgroundColor: _colors.colors.dataGrey,
          color: _colors.colors.black2
        }
      };
    },
    label: function label(_ref2) {
      var size = _ref2.size;
      return {
        fontFamily: 'Novozymes, Arial',
        fontSize: size === 'small' ? '16px' : '18px',
        lineHeight: '24px'
      };
    },
    focusVisible: {
      outline: "1px solid ".concat(_colors.colors.boxOutline)
    }
  };
});

var sizeToMuiSize = function sizeToMuiSize(size) {
  switch (size) {
    case 'small':
      return 'small';

    case 'regular':
      return 'medium';

    default:
      return undefined;
  }
};

function ButtonPrimary(props) {
  var id = props.id,
      size = props.size,
      onClick = props.onClick,
      disabled = props.disabled,
      children = props.children;
  var classes = useStyles(props);
  var mUISize = sizeToMuiSize(size);
  var mUIStaticProps = {
    variant: 'contained',
    color: 'primary',
    disableElevation: true,
    disableFocusRipple: true
  };
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, mUIStaticProps, {
    id: id,
    size: mUISize,
    classes: classes,
    onClick: onClick,
    disabled: disabled,
    type: props.type
  }), children);
}

ButtonPrimary.defaultProps = {
  size: 'regular',
  disabled: false,
  type: 'button'
};